import { render, staticRenderFns } from "./ConversationCreate.vue?vue&type=template&id=6ab0fb22&"
import script from "./ConversationCreate.vue?vue&type=script&lang=js&"
export * from "./ConversationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports